'use client';

import GtagService from '@/services/Gtag.service';
import Link from '@/components/link-with-utms';

function clickOnRegister() {
  GtagService.eventSignupClick(`footer`);
}
export default function LiLinkCadastro() {
  return (
    <li onClick={clickOnRegister}>
      <Link href="/cadastro">Cadastrar</Link>
    </li>
  );
}
